import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import { styled } from 'styled-components';
const Group = styled.div `
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  margin: -2px;
  > * {
    margin: 2px;
  }
`;
export const Wrapper = styled.span `
  display: inline-flex;
  padding: 5px;
  min-width: 42px;
  font-size: 10px;
  line-height: 1;
  font-weight: 500;
  justify-content: center;
  color: ${({ $bgColor, theme }) => ($bgColor ? theme.colors.grey00_2 : theme.colors.black_1)};
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  border-radius: 3px;
  background-color: ${({ $bgColor, theme }) => $bgColor || theme.colors.grey00_1};
  cursor: ${({ onClick }) => !!onClick && 'pointer'};
  white-space: ${({ $nowrap }) => $nowrap && 'nowrap'};
`;
const Tag = ({ color, className, value, onClick, $nowrap, dataTestId }) => (_jsx(Wrapper, { className: className, $bgColor: color, onClick: onClick, $nowrap: $nowrap, "data-testid": dataTestId, children: value }));
const TagMemo = React.memo(Tag);
const TagWrapper = (props, dataTestId) => _jsx(TagMemo, { ...props, "data-testid": dataTestId });
TagWrapper.Group = Group;
export default TagWrapper;
